// extracted by mini-css-extract-plugin
export default {"resetBtn":"ResetFiltersBtn_resetBtn__aOwG1"};